import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 48px;
  background: var(--task-eva-header);
  position: relative;
  box-shadow: var(--task-eva-header-shadow);
  .left,
  .right {
    height: 100%;
    display: flex;
    align-items: center;
  }
  padding-left: 16px;
  * {
    box-sizing: content-box;
  }
`

export const LogoWrap = styled.div`
  width: 77px;
`

export const HeaderItem = styled.div<{
  width?: string
  align?: string
  padding?: string
  active?: boolean
  maxContent?: boolean
}>`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${(p) =>
    p.active ? 'var(--task-eva-header-color-active)' : 'var(--task-eva-header-color)'};
  gap: 6px;
  user-select: none;
  &.button {
    cursor: pointer;
  }
  width: ${(p) => (p.maxContent ? 'max-content' : p.width || '96px')};
  min-width: max-content;
  justify-content: ${(p) => p.align || 'center'};
  padding: ${(p) => p.padding};
  font-size: 14px;
  .message-icon {
    position: relative;
  }
`

export const OrangeRadio = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffc266;
  position: absolute;
  left: 12px;
  top: -1px;
`

export const HeaderItemGapLine = styled.div`
  height: 30px;
  border-right: 1px solid #43454d;
`

export const UsernameIcon = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 16px;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  border: 1px solid transparent;
  background: var(--task-user-icon-background);
  text-align: center;
  color: #ffffff;
  margin-right: 6px;
  display: flex;
  align-items: center;
  div {
    flex: 1;
  }
`
